import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';

function logOrderToAzureQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function logOrderToAzureInput(cartId: string, cartJson: string, deliveryDatesJson: string): IDataServiceRequest {
    const query = logOrderToAzureQuery();
    return query.createDataServiceRequestForOperation(
        'LogOrderToAzure',
        true,
        'ResponseExtensionClass',
        'false',
        { bypassCache: 'get', returnEntity: 'Response' },
        {
            cartId: cartId,
            cartJson: cartJson,
            deliveryDatesJson: deliveryDatesJson
        }
    );
}

export function logOrderToAzureAsync(
    context: IContext,
    cartId: string,
    cartJson: string,
    deliveryDatesJson: string
): AsyncResult<Response> {
    const request = logOrderToAzureInput(cartId, cartJson, deliveryDatesJson);
    return callActionOrExecute<Response>(request, context.callerContext);
}
